import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import './navbar.css';

const Navbar = ({ onToggle }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const NavbarItems = [
    { name: 'Dashboard', icon: 'fas fa-home', link: '/dashboard' },
    { name: 'Assigned', icon: 'fas fa-user', link: '/assigned' },
    { name: 'Issues', icon: 'fas fa-exclamation-circle', link: '/issues' },
    { name: 'Logout', icon: 'fas fa-sign-out-alt', link: '/logout' },
  ];

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
    onToggle(!isOpen);
  };

  // Logout confirmation handlers
  const handleLogoutConfirm = () => {
    setShowLogoutModal(false);
    // Insert any additional logout logic here (e.g., clearing auth tokens)
    navigate('/logout');
  };

  const handleLogoutCancel = () => {
    setShowLogoutModal(false);
  };

  return (
    <>
      <aside>
        <nav className={isOpen ? 'navOpen' : 'navClose'}>
          {/* Toggle Button (desktop only) */}
          <div
            onClick={toggleNavbar}
            className={
              isOpen
                ? 'nav__button fas fa-chevron-left'
                : 'nav__button fas fa-chevron-right'
            }
          />
          
          {/* Logo (desktop only) */}
          <div className="nav__logo">
            <img
              src={logo}
              alt="Logo"
              className={isOpen ? 'logo-open' : 'logo-close'}
            />
          </div>
          
          {/* Menu Items */}
          <div className="nav__menu">
            <div className="nav__list">
              {NavbarItems.map((item, index) => {
                // For Logout, open the modal instead of navigating directly.
                if (item.name === 'Logout') {
                  return (
                    <div
                      key={index}
                      className="nav__item"
                      onClick={() => setShowLogoutModal(true)}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="nav__link">
                        {isOpen ? item.name : <i className={item.icon}></i>}
                      </div>
                    </div>
                  );
                }
                return (
                  <Link
                    key={index}
                    className={`nav__item ${
                      location.pathname === item.link ? 'active' : ''
                    }`}
                    to={item.link}
                  >
                    <div className="nav__link">
                      {isOpen ? item.name : <i className={item.icon}></i>}
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </nav>
      </aside>

      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="modal-overlay">
          <div className="delete-content">
            <h2>Are you sure you want to logout?</h2>
            <div className="modal-actions">
              <button className="confirm-button" onClick={handleLogoutConfirm}>
                Yes
              </button>
              <button className="cancel-button" onClick={handleLogoutCancel}>
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
